/* tslint:disable */
/* eslint-disable */
/**
 * AMJ Accounts Service REST API
 * Maintain AMJ Accounts data
 *
 * The version of the OpenAPI document: 1.0
 * Contact: mail@fidrees.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base';
/**
 * SuspensionNoticeControllerApi - axios parameter creator
 * @export
 */
export const SuspensionNoticeControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuspensionNotice: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/suspension-notice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer Authentication required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SuspensionNoticeDto} suspensionNoticeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuspensionNotice: (suspensionNoticeDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'suspensionNoticeDto' is not null or undefined
            assertParamExists('updateSuspensionNotice', 'suspensionNoticeDto', suspensionNoticeDto);
            const localVarPath = `/api/suspension-notice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer Authentication required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(suspensionNoticeDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SuspensionNoticeControllerApi - functional programming interface
 * @export
 */
export const SuspensionNoticeControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = SuspensionNoticeControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuspensionNotice(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSuspensionNotice(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SuspensionNoticeControllerApi.getSuspensionNotice']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {SuspensionNoticeDto} suspensionNoticeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuspensionNotice(suspensionNoticeDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateSuspensionNotice(suspensionNoticeDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SuspensionNoticeControllerApi.updateSuspensionNotice']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * SuspensionNoticeControllerApi - factory interface
 * @export
 */
export const SuspensionNoticeControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SuspensionNoticeControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuspensionNotice(options) {
            return localVarFp.getSuspensionNotice(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SuspensionNoticeDto} suspensionNoticeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuspensionNotice(suspensionNoticeDto, options) {
            return localVarFp.updateSuspensionNotice(suspensionNoticeDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SuspensionNoticeControllerApi - object-oriented interface
 * @export
 * @class SuspensionNoticeControllerApi
 * @extends {BaseAPI}
 */
export class SuspensionNoticeControllerApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuspensionNoticeControllerApi
     */
    getSuspensionNotice(options) {
        return SuspensionNoticeControllerApiFp(this.configuration).getSuspensionNotice(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SuspensionNoticeDto} suspensionNoticeDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuspensionNoticeControllerApi
     */
    updateSuspensionNotice(suspensionNoticeDto, options) {
        return SuspensionNoticeControllerApiFp(this.configuration).updateSuspensionNotice(suspensionNoticeDto, options).then((request) => request(this.axios, this.basePath));
    }
}
